// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#SaleComments_component {
  margin-bottom: 20px;
  overflow: auto;
  display: block;
  width: 100%;
}
#SaleComments_component #SaleCommentsList_component label {
  margin-bottom: 10px;
  font-weight: bold;
}
#SaleComments_component #SaleCommentsList_component .select-box {
  display: inline-block;
  background-color: #F4F4F4;
  padding: 5px 5px;
  border-radius: 5px;
  border-color: #F4F4F4;
  font-weight: bold;
}
#SaleComments_component #SaleCommentsList_component .no-comments-section {
  text-align: center;
  font-style: italic;
  display: block;
}
#SaleComments_component .accordion-body {
  padding: 5px 10px !important;
}

.pink-border-top {
  border-top: 1px solid #d2d2d2;
  padding-top: 15px;
}

.text_field textarea {
  background-color: #ededed;
}

.SaleComment_component {
  padding: 10px 15px;
  background-color: #F4F4F4;
  margin-bottom: 5px;
}
.SaleComment_component .border-bottom {
  border-bottom: 1px solid #d2d2d2;
}

#SaleCommentForm_component .select-box {
  display: inline-block;
  background-color: #F4F4F4;
  padding: 5px 5px;
  border-radius: 5px;
  border-color: #F4F4F4;
  margin-left: 10px;
  float: right;
}
#SaleCommentForm_component .select-box:focus {
  outline: none;
  box-shadow: none;
}
#SaleCommentForm_component .submit_field {
  text-align: right;
}
#SaleCommentForm_component .submit_field .submit-btn {
  background-color: black;
  display: inline-block;
  color: #fff;
  text-align: center;
  font-size: 12px;
  line-height: 14px;
  padding: 5px 25px;
  text-transform: uppercase;
}
#SaleCommentForm_component .comment-label {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/css/sales/sale_comments.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EAEA,cAAA;EACA,cAAA;EACA,WAAA;AAAJ;AAEQ;EACI,mBAAA;EACA,iBAAA;AAAZ;AAEQ;EACI,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;AAAZ;AAEQ;EACI,kBAAA;EACA,kBAAA;EACA,cAAA;AAAZ;AAGI;EACI,4BAAA;AADR;;AAKA;EACI,6BAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,yBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,yBAAA;EACA,kBAAA;AAFJ;AAGI;EACI,gCAAA;AADR;;AAOI;EACI,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,YAAA;AAJR;AAKQ;EACI,aAAA;EACA,gBAAA;AAHZ;AAMI;EACI,iBAAA;AAJR;AAKQ;EACI,uBAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;AAHZ;AAMI;EACI,iBAAA;AAJR","sourcesContent":["#SaleComments_component {\n    margin-bottom: 20px;\n    // max-height: 340px;\n    overflow: auto;\n    display: block;\n    width: 100%;\n    #SaleCommentsList_component {\n        label {\n            margin-bottom: 10px;\n            font-weight: bold;\n        }\n        .select-box {\n            display: inline-block;\n            background-color: #F4F4F4;\n            padding: 5px 5px;\n            border-radius: 5px;\n            border-color: #F4F4F4;\n            font-weight: bold;\n        }\n        .no-comments-section {\n            text-align: center;\n            font-style: italic;\n            display: block;\n        }\n    }\n    .accordion-body {\n        padding: 5px 10px !important;\n    }\n}\n\n.pink-border-top {\n    border-top: 1px solid #d2d2d2;\n    padding-top: 15px;\n}\n\n.text_field textarea {\n    background-color: #ededed;\n}\n\n.SaleComment_component {\n    padding: 10px 15px;\n    background-color: #F4F4F4;\n    margin-bottom: 5px;\n    .border-bottom {\n        border-bottom: 1px solid #d2d2d2;\n    }\n}\n\n#SaleCommentForm_component {\n    // margin-bottom: 20px;\n    .select-box {\n        display: inline-block;\n        background-color: #F4F4F4;\n        padding: 5px 5px;\n        border-radius: 5px;\n        border-color: #F4F4F4;\n        margin-left: 10px;\n        float: right;\n        &:focus {\n            outline: none;\n            box-shadow: none;\n        }\n    }\n    .submit_field {\n        text-align: right;\n        .submit-btn {\n            background-color: black;\n            display: inline-block;\n            color: #fff;\n            text-align: center;\n            font-size: 12px;\n            line-height: 14px;\n            padding: 5px 25px;\n            text-transform: uppercase;\n        }\n    }\n    .comment-label {\n        font-weight: bold;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
